/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_PhoneInputs */

const vi_report_debt_phone = /** @type {(inputs: Report_Debt_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SĐT`)
};

/**

* @param {Report_Debt_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_phone = /** @type {((inputs?: Report_Debt_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_phone(inputs)
});